import { render, staticRenderFns } from "./Pig.vue?vue&type=template&id=4f1bdcb6&lang=pug&"
import script from "./Pig.vue?vue&type=script&lang=js&"
export * from "./Pig.vue?vue&type=script&lang=js&"
import style0 from "./Pig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports